
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
    selector: 'feeling-list-selection',
    templateUrl: 'feeling-list-selection.component.html',
})

export class FeelingListSelectionComponent {

    @Input() symptom: any;
    @Input() selectionList;
    @Input() nodeClassList: any;
    @Input() lang: any;
    @Input() activeDomain : any;

    @Output() changeRating = new EventEmitter();
    @Output() changePrimary = new EventEmitter();
    @Output() changeActiveSymptom = new EventEmitter();

    updateRatingTaskList(activeDomain,symptom, position, status, isAnamnestic = 0) {
        this.changeRating.emit({
            activeDomain : activeDomain,
            symptom : symptom,
            position : position,
            status : status,
            isAnamnestic : isAnamnestic
        });
    }

    updatePrimary(feeling, symptom) {
        this.changePrimary.emit({
            feeling: feeling,
            symptom: symptom
        })
    }

    setActiveSymptom(symptom, activeDomain) {
        this.changeActiveSymptom.emit({
            symptom: symptom,
            activeDomain: activeDomain
        })
    }

    primaryItemName(symptom){
        if(symptom.feelings.length === 1){
            return '';
        }
        const primaryFeeling = symptom.feelings.filter(feeling => {
            return feeling.is_primary_on_map;
        });
        if(primaryFeeling.length === 0){
            return '';
        }
        return primaryFeeling[0]['name_' + this.lang];
    }
}
